
define('template!shareProductCodeVariationsTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="productcodevariation-items">\n\n</div>';

}
return __p
};});

